import script from "./AdPlatformAppView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdPlatformAppView.vue?vue&type=script&setup=true&lang=js"

import "./AdPlatformAppView.vue?vue&type=style&index=0&id=545d9181&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545d9181"]])

export default __exports__